"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var assetManager_1 = require("../../../../common/service/assetManager");
var constants_1 = require("../../../../common/constants/constants");
var renderPaymentProviderVisaNet = function (_a) {
    var parentNodeId = _a.parentNodeId, merchantLogo = _a.merchantLogo, className = _a.className, _b = _a.paymentData, formUrl = _b.formUrl, sessionToken = _b.sessionToken, merchantId = _b.merchantId, purchaseNumber = _b.purchaseNumber, amount = _b.amount, cardHolderEmail = _b.cardHolderEmail, cardHolderLastName = _b.cardHolderLastName, cardHolderName = _b.cardHolderName;
    return Promise.resolve().then(function () {
        var paymentContainer = document.querySelectorAll("[data-test='" + parentNodeId + "']")[0];
        var form = document.createElement('form');
        form.dataset.test = 'form:checkout:payHereForm';
        form.action = formUrl;
        form.method = 'POST';
        form.className = className;
        form.id = 'form:checkout:payHereForm';
        var scriptDataSet = {
            sessiontoken: sessionToken,
            channel: 'web',
            merchantid: merchantId,
            merchantlogo: merchantLogo,
            purchasenumber: purchaseNumber,
            amount: amount,
            amoexpirationminutesunt: '5',
            timeouturl: 'timeout.html',
            cardholdername: cardHolderName,
            cardholderlastname: cardHolderLastName,
            cardholderemail: cardHolderEmail,
            buttonsize: 'large',
            buttoncolor: 'navy',
            formbuttoncolor: '#00adee',
            showamount: 'true',
            merchantname: 'Subaru',
            test: 'script:checkout:visaNet',
        };
        // If user goes Payment->Enquiry->Payment using back/forward buttons
        // The VisaNet button will not render again
        // For this, we delete its info from the window.
        if (window.VisanetCheckout) {
            delete window.VisanetCheckout;
        }
        paymentContainer.appendChild(form);
        return assetManager_1.assetManager.appendScriptToElement('form:checkout:payHereForm', constants_1.default.VISANET_CHECKOUT_RESOURCE_URL, scriptDataSet);
    });
};
exports.default = renderPaymentProviderVisaNet;
